import { produce, Draft } from 'immer'
import { IAction, TActionTypes } from '@Root/types'
import map from 'lodash/map'

import {
  IThemeState,
  ThemeActionTypes,
  TThemeActionTypes,
  IFetchThemesSuccessResponseBody,
} from './types'

export const initialState: IThemeState = {
  themes: [],
  loading: false,
  hasLoadedInitially: false
}

type TAction = TActionTypes | TThemeActionTypes

export const themesReducer  = (
  state: IThemeState = initialState,
  action: TAction
): IThemeState => {
  return produce(state, draft => {
    switch (action.type) {
      case ThemeActionTypes.FETCH_THEMES:
        fetchThemes(draft)
        break

      case ThemeActionTypes.FETCH_THEMES_SUCCESS:
        fetchThemesSuccess(draft, action)
        break

      case ThemeActionTypes.FETCH_THEMES_FAILURE:
        fetchThemesFailure(draft)
        break

      default:
        break
    }
  })
}

const fetchThemes = (draft: Draft<IThemeState>) => {
  draft.loading = true
}

function isIFetchThemesSuccessAction(arg: any): arg is IAction<IFetchThemesSuccessResponseBody> {
  return arg.type === ThemeActionTypes.FETCH_THEMES_SUCCESS
}

const fetchThemesSuccess = (draft: Draft<IThemeState>, action: TAction) => {
  if (!isIFetchThemesSuccessAction(action)) { return }

  draft.themes= map(action.payload.data, data => {
    return ({
      id: parseInt(data.id, 10),
      attributes: data.attributes
    })
  })
  draft.loading = false
  draft.hasLoadedInitially = true
}

const fetchThemesFailure = (draft: Draft<IThemeState>) => {
  draft.loading = false
}
